// FoodRow.js — 음식 한 줄 (이름 · kcal · 탄/단/지). 음식검색·내 음식·음식풀·고르기 창 공용
import React from 'react';
import { fmt, MacroText } from './Nutrients';
import './ui.css';

export default function FoodRow({ food, meta, selected, onClick, right }) {
  const clickable = !!onClick;
  return (
    <div
      className={`food-row${selected ? ' selected' : ''}${clickable ? ' clickable' : ''}`}
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter') onClick(); } : undefined}
    >
      <div className="food-row-main">
        <strong>{food.foodNm}</strong>
        {meta && <span className="food-row-meta">{meta}</span>}
      </div>
      <span className="food-row-kcal">{fmt(food.kcal)} kcal</span>
      <MacroText carbo={food.carbo} protein={food.protein} fat={food.fat} />
      {right}
    </div>
  );
}
